<template>
  <v-container>
    <h1 v-if='runDocuments.length <= 0'>Handbuch</h1>
    <h1 v-else-if='runDocuments.length > 1'>Handbücher</h1>
    <template v-if='runDocuments.length > 0'>
      <v-expansion-panels accordion='accordion' v-model='panel'>
        <v-expansion-panel v-for='item in runDocuments' :key='`manual_${item.id}`'>
          <v-expansion-panel-header>
            <div><v-icon class='pr-2 primary--text'>mdi-file-pdf</v-icon>{{item.name}}</div>
          </v-expansion-panel-header>
          <v-expansion-panel-content style='height:66vh'>
            <Pdf :pdf-url='item.url'/>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </template>
    <div v-else style="height: 66vh">
      <div>Kein Handbuch verfügbar</div>
    </div>

  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import LoadingState from '@/api/LoadingState';
import Pdf from './Pdf.vue';

export default {
  // eslint-disable vue/multi-word-component-names
  name: 'Manual',
  components: {
    Pdf,
  },
  data: () => ({
    editor: null,
    penInk: '',
    observationData: null,
    currentObservation: {},
    panel: 0
  }),
  computed: {
    ...mapState({
      runDocuments: (state) => state.run.runInformation.documents,
    })
  },
  methods: {},
  mounted() {},
  beforeDestroy() {},
};
</script>
